import Nav from 'react-bootstrap/Nav';
import { useProSidebar } from 'react-pro-sidebar';
import * as Icon from 'react-icons/md';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useDispatch, useSelector } from 'react-redux';
import { signOut } from '../../../reducers/authSlice';
import { RootState } from '../../../app/store';
import { useEffect, useState } from 'react';
import jwt_decode from 'jwt-decode';

function Header() {
    const dispatch = useDispatch();
    const { token } = useSelector((state: RootState) => state.auth);
    const [userName, setUserName] = useState('User');

    useEffect(() => {
        if (token) {
            try {
                const decodedToken: any = jwt_decode(token);
                // Set username from token data
                if (decodedToken.displayName) {
                    setUserName(decodedToken.displayName);
                } else if (decodedToken.username) {
                    setUserName(decodedToken.username);
                } else if (decodedToken.email) {
                    setUserName(decodedToken.email);
                }
            } catch (error) {
                console.error('Failed to decode token:', error);
            }
        }
    }, [token]);

    const { collapseSidebar } = useProSidebar();

    const onLogout = () => {
        dispatch(signOut());
    }

    return (
        <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flex: 1 }}>
                <Icon.MdMenu onClick={() => collapseSidebar()} size={30} />
                <Navbar.Collapse id="responsive-navbar-nav" style={{ justifyContent: 'flex-end' }}>
                    <Nav>
                        <NavDropdown title={userName} id="collasible-nav-dropdown">
                            <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.2">
                                Another action
                            </NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item onClick={onLogout}>
                                Logout
                            </NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </div>
        </Navbar>
    );
}

export default Header;
